import * as React from "react";
import type { SVGProps } from "react";
const SvgLock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#lock_svg__a)">
      <path d="M17 22H7c-1.65 0-3-1.35-3-3v-7c0-1.65 1.35-3 3-3h10c1.65 0 3 1.35 3 3v7c0 1.65-1.35 3-3 3M7 11c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-7c0-.55-.45-1-1-1z" />
      <path d="M16 11c-.55 0-1-.45-1-1V7c0-1.65-1.35-3-3-3S9 5.35 9 7v3c0 .55-.45 1-1 1s-1-.45-1-1V7c0-2.76 2.24-5 5-5s5 2.24 5 5v3c0 .55-.45 1-1 1M12 19c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3m0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1" />
    </g>
    <defs>
      <clipPath id="lock_svg__a">
        <path fill="#fff" d="M4 2h16v20H4z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLock;
